import React from "react";

import { UserShopPage } from "../../components/user/index.js";

export default ({ match }) => <UserShopPage clientNumber={match.params.clientNumber} />;
